import { render, staticRenderFns } from "./TargetGroupManage.vue?vue&type=template&id=3d5f545e&scoped=true&"
import script from "./TargetGroupManage.vue?vue&type=script&lang=js&"
export * from "./TargetGroupManage.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroupManage.vue?vue&type=style&index=0&id=3d5f545e&lang=scss&"
import style1 from "./TargetGroupManage.vue?vue&type=style&index=1&id=3d5f545e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f545e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d5f545e')) {
      api.createRecord('3d5f545e', component.options)
    } else {
      api.reload('3d5f545e', component.options)
    }
    module.hot.accept("./TargetGroupManage.vue?vue&type=template&id=3d5f545e&scoped=true&", function () {
      api.rerender('3d5f545e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/target-group-manage/TargetGroupManage.vue"
export default component.exports